import { render, staticRenderFns } from "./BurgerMenuSatelliteMobile.vue?vue&type=template&id=22f2afc6"
import script from "./BurgerMenuSatelliteMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./BurgerMenuSatelliteMobile.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports